import React from 'react';
import '../template-file-css/document-file-template.css';



export const RRTS_IndividualizedCrisisPlan = ({
    itemsRef,
    showErrorFor,
    
}) => {

    return (
        <form id='RRTS_IndividualizedCrisisPlan' className='file-pdf-document'>
            <div className='file-template'>
               
            <p className='w-750'><h3>INDIVIDUALIZED CRISIS PLAN</h3>
                </p>
                <p className='w-750'><b>Instructions:</b>
                    <span className='small'>This plan is to ensure the health and safety of CPST/PSR Recipients.  All sections below must be fully completed, agreed upon by the recipient, and written in language the recipient understands</span>
                    <b>The recipient and natural supports must receive a copy of this plan.</b>
                </p>
                <table>
                    <tr >
                        <td className='w-750'> <span className='eleHeader'>1.	Describe what constitutes a crisis for the recipient:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbDescribeWhatConstitutesCrisisRecipientSuicideAttempt' name='cbDescribeWhatConstitutesCrisisRecipientSuicideAttempt' className='add-only' value='SuicideAttempt' /> Suicide Attempt</td>
                        <td className='w-250'><input type='checkbox' id='cbDescribeWhatConstitutesCrisisRecipientSuicidalStatedPlanIntent' name='cbDescribeWhatConstitutesCrisisRecipientSuicidalStatedPlanIntent' className='add-only' value='SuicidalStatedPlanIntent' /> Suicidal Stated Plan/Intent</td>
                        <td className='w-250'><input type='checkbox' id='cbDescribeWhatConstitutesCrisisRecipientHomicidalAttemptPlan' name='cbDescribeWhatConstitutesCrisisRecipientHomicidalAttemptPlan' className='add-only' value='HomicidalAttemptPlan' /> Homicidal Attempt of Plan</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbDescribeWhatConstitutesCrisisRecipientAngryMoodAgitation' name='cbDescribeWhatConstitutesCrisisRecipientAngryMoodAgitation' className='add-only' value='AngryMoodAgitation' /> Angry Mood/Agitation</td>
                        <td className='w-375'><input type='checkbox' id='cbDescribeWhatConstitutesCrisisRecipientPsychosisCommandHallucinations' name='cbDescribeWhatConstitutesCrisisRecipientPsychosisCommandHallucinations' className='add-only' value='PsychosisCommandHallucinations' /> Psychosis/Command Hallucinations</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbDescribeWhatConstitutesCrisisRecipientOutControlDangerousImpulsiveBehaviors' name='cbDescribeWhatConstitutesCrisisRecipientOutControlDangerousImpulsiveBehaviors' className='add-only' value='OutControlDangerousImpulsiveBehaviors' /> Out of Control/Dangerous/Impulsive Behaviors
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbDescribeWhatConstitutesCrisisRecipientOtherExplain' name='cbDescribeWhatConstitutesCrisisRecipientOtherExplain' className='add-only' value='OtherExplain' /> Other/Explain:
                            <input type='text' id='txtDescribeWhatConstitutesCrisisRecipientOtherExplain' name='txtDescribeWhatConstitutesCrisisRecipientOtherExplain' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr >
                        <td className='w-750'> <span className='eleHeader'>2.	Describe events/situations that may be precipitates to a crisis:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbDescribeEventsSituationsPrecipitatesCrisisAngryOutburst' name='cbDescribeEventsSituationsPrecipitatesCrisisAngryOutburst' className='add-only' value='AngryOutburst' /> Angry Outburst</td>
                        <td className='w-250'><input type='checkbox' id='cbDescribeEventsSituationsPrecipitatesCrisisBeingToldNo' name='cbDescribeEventsSituationsPrecipitatesCrisisBeingToldNo' className='add-only' value='BeingToldNo' /> Being Told No</td>
                        <td className='w-250'><input type='checkbox' id='cbDescribeEventsSituationsPrecipitatesCrisisFearAnxietyStress' name='cbDescribeEventsSituationsPrecipitatesCrisisFearAnxietyStress' className='add-only' value='FearAnxietyStress' /> Fear/Anxiety/Stress</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbDescribeEventsSituationsPrecipitatesCrisisPoorSchoolWorkPerformance' name='cbDescribeEventsSituationsPrecipitatesCrisisPoorSchoolWorkPerformance' className='add-only' value='PoorSchoolWorkPerformance' /> Poor School/Work Performance</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbDescribeEventsSituationsPrecipitatesCrisisOtherPeopleWhom' name='cbDescribeEventsSituationsPrecipitatesCrisisOtherPeopleWhom' className='add-only' value='OtherPeopleWhom' /> Other People: Whom:
                            <input type='text' id='txtDescribeEventsSituationsPrecipitatesCrisisOtherPeopleWhom' name='txtDescribeEventsSituationsPrecipitatesCrisisOtherPeopleWhom' className='add-only w-575 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbDescribeEventsSituationsPrecipitatesCrisisOtherExplain' name='cbDescribeEventsSituationsPrecipitatesCrisisOtherExplain' className='add-only' value='OtherExplain' /> Other/Explain:
                            <input type='text' id='txtDescribeEventsSituationsPrecipitatesCrisisOtherExplain' name='txtDescribeEventsSituationsPrecipitatesCrisisOtherExplain' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr >
                        <td className='w-750'> <span className='eleHeader'>3.	Describe what action (s) can be taken by the recipient and/or natural supports to address the crisis:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbDescribeWhatActionTakenRecipientNaturalSupportsAddressCrisisDeepBreathingExercises' name='cbDescribeWhatActionTakenRecipientNaturalSupportsAddressCrisisDeepBreathingExercises' className='add-only' value='DeepBreathingExercises' /> Deep Breathing Exercises </td>
                        <td className='w-250'><input type='checkbox' id='cbDescribeWhatActionTakenRecipientNaturalSupportsAddressCrisisGuidedVisualImagery' name='cbDescribeWhatActionTakenRecipientNaturalSupportsAddressCrisisGuidedVisualImagery' className='add-only' value='GuidedVisualImagery' /> Guided Visual Imagery </td>
                        <td className='w-250'><input type='checkbox' id='cbDescribeWhatActionTakenRecipientNaturalSupportsAddressCrisisPersonalTimeout' name='cbDescribeWhatActionTakenRecipientNaturalSupportsAddressCrisisPersonalTimeout' className='add-only' value='PersonalTimeout' /> Personal Timeout </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbDescribeWhatActionTakenRecipientNaturalSupportsAddressCrisisJournalingFreeWriting' name='cbDescribeWhatActionTakenRecipientNaturalSupportsAddressCrisisJournalingFreeWriting' className='add-only' value='JournalingFreeWriting' /> Journaling or Free Writing </td>
                        <td className='w-375'><input type='checkbox' id='cbDescribeWhatActionTakenRecipientNaturalSupportsAddressCrisisTalkToParentTrustedAdult' name='cbDescribeWhatActionTakenRecipientNaturalSupportsAddressCrisisTalkToParentTrustedAdult' className='add-only' value='TalkToParentTrustedAdult' /> Talk to a Parent or Trusted Adult</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbDescribeWhatActionTakenRecipientNaturalSupportsAddressCrisisContactYourMentalHealthProfessionalForAssistance' name='cbDescribeWhatActionTakenRecipientNaturalSupportsAddressCrisisContactYourMentalHealthProfessionalForAssistance' className='add-only' value='ContactYourMentalHealthProfessionalForAssistance' /> Contact your Mental Health Professional for Assistance
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbDescribeWhatActionTakenRecipientNaturalSupportsAddressCrisisOtherExplain' name='cbDescribeWhatActionTakenRecipientNaturalSupportsAddressCrisisOtherExplain' className='add-only' value='OtherExplain' /> Other/Explain:
                            <input type='text' id='txtDescribeWhatActionTakenRecipientNaturalSupportsAddressCrisisOtherExplain' name='txtDescribeWhatActionTakenRecipientNaturalSupportsAddressCrisisOtherExplain' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3>
                        4.	Describe what action (s) can be taken by the CPST/PSR Provider:
                    </h3>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>CPST/PSR Provider will respond immediately and assess the situation</span>
                    <textarea id="txtCpstPsrProviderRespondImmediatelyAssessSituation" name="txtCpstPsrProviderRespondImmediatelyAssessSituation" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>CPST/PSR Provider will contact LPC immediately in the event of a crisis</span>
                    <textarea id="txtCpstPsrProviderWillContactLpcImmediatelyInTheEventCrisis" name="txtCpstPsrProviderWillContactLpcImmediatelyInTheEventCrisis" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>CPST/PSR Provider will provide client with de-escalation tools until client is calm</span>
                    <textarea id="txtCpstPsrProviderWillProvideClientWithEscalationToolsUntilClientIsCalm" name="txtCpstPsrProviderWillProvideClientWithEscalationToolsUntilClientIsCalm" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>5.	Name, address, phone number of supporters the recipient wishes to help them when at risk of entering or in a crisis:</span>
                    <textarea id="txtNameAddressPhoneNumberOfSupportersTheRecipientWishesToHelpThemWhenAtRiskOfEnteringOrInCrisis" name="txtNameAddressPhoneNumberOfSupportersTheRecipientWishesToHelpThemWhenAtRiskOfEnteringOrInCrisis" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>6.	Name, title, and contact information for the primary CPST/PSR Worker and other agency support staff including the LMHP and the psychiatric director: </span>
                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> - CPST/PSR Worker </td>
                        <td className='small w-375'> - Phone Number </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Crisis Hotline </span>
                            <td className='w-375'> <input type='text' id="txtCrisisHotline" name="txtCrisisHotline" className='add-only' placeholder='318-987-1992 ' /></td>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Clinical Director  </span>
                            <td className='w-375'> <input type='text' id="txtClinicalDirector" name="txtClinicalDirector" className='add-only' placeholder='318-220-8423 ' /></td>
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>Dr. Gregory Brown MD., Medical Director</b> <br />
                    <h3>IF AT ANY TIME THERE IS IMMEDIATE DANGER, CALL 911.</h3>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>7.	Other instructions from recipient:</span>
                    <textarea id="txtOtherInstructionsFromRecipient" name="txtOtherInstructionsFromRecipient" className='add-only'></textarea>
                </p>
                <h3>Signatures:</h3>
                <p className='w-750'>
                    <span className='eleHeader'>Individuals participating in the development of this Crisis Plan must sign below:</span>
                </p>
                <table>
                    <tr>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-125'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-125'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-250'> Recipient </td>
                        <td className='small w-125'> Date </td>
                        <td className='small w-250'> LMHP </td>
                        <td className='small w-125'> Date </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-125'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-125'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-250'> Parent/Guardian </td>
                        <td className='small w-125'> Date </td>
                        <td className='small w-250'> Primary MHP </td>
                        <td className='small w-125'> Date </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-125'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-125'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-250'> Other </td>
                        <td className='small w-125'> Date </td>
                        <td className='small w-250'> Other </td>
                        <td className='small w-125'> Date </td>
                    </tr>
                </table> 



            </div>
        </form>

    )
}  
